const importComponent = (basePath: string, type: string) =>
  import(`@/components/page-modules/builder/components/${basePath}/${type}`);

export const findPreviewComponentForList = (type: string) =>
  importComponent("list-preview-types", type);

export const findPreviewComponent = (type: string) => importComponent("modules", type);

export const renderCustomizeComponent = (type: string) => importComponent("customize-types", type);
